module.exports = __webpack_public_path__ + "img/icatalyst.c24bedc2.png";